import React from 'react';
import {
  Box,
  Button,
  Link,
  Paper,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useCookieConsent } from '../../contexts/CookieConsentContext';
import { trackPageView } from '../../utils/analytics';

const CookieConsentBanner: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();
  const { bannerOpen, acceptAll: persistAcceptAll, acceptNecessaryOnly } = useCookieConsent();

  const acceptAll = () => {
    persistAcceptAll();
    trackPageView(`${location.pathname}${location.search}`);
  };

  if (!bannerOpen) {
    return null;
  }

  return (
    <Box
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-desc"
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: theme.zIndex.snackbar + 1,
        p: 2,
        pointerEvents: 'none',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          pointerEvents: 'auto',
          maxWidth: 960,
          mx: 'auto',
          p: { xs: 2, sm: 3 },
          borderRadius: 2,
        }}
      >
        <Stack spacing={2}>
          <Typography id="cookie-banner-title" variant="h6" component="h2" sx={{ fontWeight: 700 }}>
            Cookies &amp; Datenschutz
          </Typography>
          <Typography id="cookie-banner-desc" variant="body2" color="text.secondary">
            Wir nutzen Cookies und ähnliche Techniken, die für den Betrieb der Website nötig sind
            (z.&nbsp;B. Sicherheit, Anmeldung). Mit Ihrer Einwilligung setzen wir Google Analytics ein, um die
            Nutzung anonymisiert auszuwerten. Details finden Sie in der{' '}
            <Link component={RouterLink} to="/datenschutz" underline="hover">
              Datenschutzerklärung
            </Link>
            .
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            justifyContent="flex-end"
            alignItems={{ xs: 'stretch', sm: 'center' }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={acceptNecessaryOnly}
              sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 200 } }}
            >
              Nur notwendige
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={acceptAll}
              sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 200 } }}
            >
              Alle akzeptieren
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

export default CookieConsentBanner;
